import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CalendarClock, Loader2 } from 'lucide-react';
import { format } from 'date-fns';

const UpcomingDeadlines = ({ tasks, isLoading }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      <Card className="bg-slate-800/70 border-slate-700 shadow-xl h-full">
        <CardHeader>
          <CardTitle className="text-xl text-slate-200 flex items-center">
            <CalendarClock size={22} className="mr-2 text-amber-400" /> Upcoming Deadlines (Next 3 Days)
          </CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
             <div className="space-y-3 animate-pulse">
                {[...Array(2)].map((_, i) => (
                  <div key={i} className="h-8 bg-slate-700 rounded"></div>
                ))}
              </div>
          ) : tasks.length > 0 ? (
            <ul className="space-y-3">
              {tasks.map(task => (
                <li key={task.id} className="text-sm text-slate-300">
                  <span className="font-semibold text-amber-400">{task.name}</span>
                  {task.projects && <span className="text-xs text-slate-500"> ({task.projects.name})</span>}: Due {format(new Date(task.due_date), 'MMM d, p')}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-400 text-center py-4">No pressing deadlines in the next 3 days.</p>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default UpcomingDeadlines;